// Copyright ©️ 2026 eVolve MEP, LLC

import { type ReactNode, useState } from 'react';

import { Collapse, Box, LoadingOverlay, type BoxProps } from '@mantine/core';

type Props = {
  loading: boolean | undefined;
  /**
   * Default height of container when loading
   * @defaultValue 40px
   */
  mih?: BoxProps['mih'];
  children: ReactNode;
};

/**
 * Used to allow content to expand in naturally after loading.
 */
export const CollapseWithLoading = ({ loading = false, children, mih: initialMih = 40 }: Props) => {
  const [mih, setMih] = useState(initialMih);
  const [hasBeenExpanded, setHasBeenExpanded] = useState(false);
  return (
    <Box
      pos="relative"
      mih={mih}
      style={{
        transition: 'min-height 0.25s ease-in-out',
      }}
    >
      <Collapse
        expanded={!loading || hasBeenExpanded}
        onTransitionEnd={() => {
          setMih(0);
          setHasBeenExpanded(true);
        }}
      >
        {children}
      </Collapse>
      <LoadingOverlay visible={loading} loaderProps={{ type: 'oval' }} />
    </Box>
  );
};
